import { render, staticRenderFns } from "./NicheCategoryPopup.vue?vue&type=template&id=6bb08992"
import script from "./NicheCategoryPopup.vue?vue&type=script&lang=js"
export * from "./NicheCategoryPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports